import apiClient from './apiClient';

export interface P501ActionResponse {
  success: number;
  message: string;
}

export const p501Api = {
  async approve(requestNo: string): Promise<P501ActionResponse> {
    const response = await apiClient.post('/api/p501/approve', {
      confirmed: true,
      items: [{ no: requestNo, checked: true }],
    });
    return response.data;
  },
};

export default p501Api;
